import * as React from "react";
import * as ReactDOM from "react-dom";
import { TaskBoard, TaskBoardToolbar } from "@progress/kendo-react-taskboard";
import { Button } from "@progress/kendo-react-buttons";
import { Input } from "@progress/kendo-react-inputs";
import { filterBy } from "@progress/kendo-data-query";
import {
    TaskBoardCard,
    TaskBoardCardHeader,
    TaskBoardColumn
} from "@progress/kendo-react-taskboard";
import { Badge, BadgeContainer } from "@progress/kendo-react-indicators";
import { CardBody, CardHeader, ComboBox } from "@progress/kendo-react-all";
import moment from "moment";
import { useState } from "react";
import { SBNotify } from "../utils/sbNotify";
import { AgGridReact } from "ag-grid-react";
import { SBAComboBox } from "./SBADropDown";
import { useCallback } from "react";



const columns = [
    {
        id: 1,
        title: "To-Do",
        status: "todo",
    },
    {
        id: 2,
        title: "In Progress",
        status: "inProgress",
    },
    {
        id: 3,
        title: "Done",
        status: "done",
    },
];

export const SBTaskBoard = ({ data , updateSubTask, ownerList, editTask, deleteTask, attachment, cardOnChange, filter, editSubTask, addSubTaskToTask, taskData, setTaskData, removeSubTask }) => {
    const [columnsData, setColumnsData] = React.useState(columns);
    const [addSubTask, setAddSubTask] = React.useState(null);
    React.useEffect(() => {
        setTaskData(data);
    }, [data]);
    const resultTasks = React.useMemo(() => {
        const filterDesc = {
            logic: "and",
            filters: [
                {
                    field: "title",
                    operator: "contains",
                    value: filter,
                },
            ],            
        };
        return filter ? filterBy(taskData, filterDesc) : taskData;
    }, [filter, taskData]);
    const onChangeHandler = useCallback((event) => {
        if (event.type === "column") {
            setColumnsData(event.data);
        } 
        else if (!event.item.IsCompleted) {
            if (event.item && event.item.id === undefined) {
                event.item.id = event.data.length + 1;
                event.item.IsCompleted = true;
        }
            setTaskData(event.data);
            cardOnChange({item:event.item,previousItem:event.previousItem});
        }
    },[]);
    const ColumnHeader = (props) => {
        const { edit, title, status } = props.column;
        return (
            <div className='d-flex justify-content-between p-4 border-bottom'>
                <div >
                    {edit ? (
                        <Input
                            value={title}
                            onChange={props.onTitleChange}
                            onBlur={props.onColumnExitEdit}
                            autoFocus={true}
                        />
                    ) : (
                        <>
                            <BadgeContainer
                                style={{
                                    left: "12px",
                                    top: "-4px",
                                }}
                            >
                                <Badge
                                    themeColor={themeColor[status]}
                                    style={{
                                        zIndex: 0,
                                    }}
                                >
                                    {props.tasks && props.tasks.length}
                                </Badge>

                            </BadgeContainer>

                            <span
                                style={{
                                    marginLeft: "30px",
                                }}
                            >
                                {title}
                            </span>

                        </>
                    )}
                </div>
                <div>
                    {/* <i className="fa-solid fa-plus mx-2 SBA_hand" onClick={addTask}></i> */}
                    {/* <i className="fa-solid fa-pen mx-2 SBA_hand"  onClick={props.onColumnEnterEdit} ></i>
                   <i className="fa-solid fa-close mx-2 SBA_hand" onClick={props.onColumnDelete}></i> */}
                </div>
            </div>
        );
    };
    const Column = (props) => {
        return <TaskBoardColumn {...props} header={ColumnHeader} />;
    };
    const addSubTaskEvent = (props) => {
        setAddSubTask(props.task);
    };
    const CardHeaderComponent = (props) => {
        return <CardHeader >
            <div >
                <div className=" row" >
                    <span title={props.task.taskType} className="col-md-8">
                        {props.task.title}
                    </span>
                    <span className="d-block col-md-4 d-flex justify-content-end">
                        <span className="k-badge k-badge-md k-badge-solid mx-1 text-white bg-sba rounded p-1 SBA_hand" style={{ height: '20px', width: '12.26px', marginTop: '-2px' }} onClick={() => attachment(props)}>
                            {props.task.AttachmentCount}
                        </span>
                        <i className={`fa-solid  fa-paperclip  mx-1  SBA_hand`} onClick={() => attachment(props)} />
                        {!props.task.IsCompleted && <i className={`fa-solid fa-edit mx-1    ${props.task.IsCompleted ? 'text-secondary' : 'text-success'} SBA_hand`} onClick={() => editTask(props)} />}
                        {!props.task.IsCompleted && <i className={`fa-solid fa-trash mx-1 ${props.task.IsCompleted ? 'text-secondary' : 'text-danger'}  SBA_hand`} onClick={() => deleteTask(props)} />}
                        {!props.task.IsCompleted && <i className={`fa-solid fa-add mx-1 ${props.task.IsCompleted ? 'display-none' : 'text-success'}  SBA_hand`} onClick={() => addSubTaskEvent(props)} />}
                    </span>
                </div>
            </div>
        </CardHeader>
    };
    const CardBodyComponent = (props) => {
        const dueDateWarning = (new Date(props.task.DueDateTime) > new Date() || props.task.IsCompleted) ? 'bg-white' : 'bg-danger text-white'
        const progressBarColor = (props.task.SubTasksList.filter(item => item.IsCompleted).length / props.task.SubTasksList.length) === 1 ? 'bg-success' :'bg-sba';
        const entityType=props.task.EntityTypeName;
        const entityName=props.task.EntityName;
        const entityNameStyles={
            overflow:'hidden',textOverflow:'ellipsis', whiteSpace:'nowrap',
            width:'150px'
        };
        return (
            <CardBody title={props.task.taskType}>
                <div className="d-flex justify-content-between">
                <div style={{ width: '25%', height: '5px', backgroundColor: `${props.task.TaskTypeColor}` }} ></div>
                <div className="d-flex " >
                    {
                        entityName &&<>
                        {entityType==="Contact" && <><img src="/images/contact.svg" title="Contact" style={{width:'24px' , height:'24px'}} /> <p style={entityNameStyles} title={entityName}> 
                {entityName}
                    </p>
                    </> }
                {entityType==="Account" && <><img src="/images/account.svg" title="Account" style={{width:'24px' , height:'24px'}} /><p style={entityNameStyles} title={entityName}> 
                 {entityName}
                 </p></>}
                        </>
                    }
                
                </div>

                </div>
                <div dangerouslySetInnerHTML={{ __html: props.task.description }} style={{ marginTop: '10px' }}></div>
                <div className="dateContainer d-flex gap-2" >
                    <span className="startDate">
                        <i className="fas fa-calendar-alt mx-2"></i>{moment(props.task.StartDateTime).format('MM/DD/YYYY')}
                    </span>
                    <span className={`endDate ${dueDateWarning}`}  >
                        <i className="fas fa-calendar-alt mx-2"></i>{props.task.IsCompleted ? moment(props.task.CompletedDate).format('MM/DD/YYYY') : moment(props.task.DueDateTime).format('MM/DD/YYYY')}
                    </span>
                </div>
                {props.task.SubTasksList.length > 0 && <> <hr />  <div className="d-flex justify-content-between">
                    <div><span className={`k-badge k-badge-md k-badge-solid  k-rounded-md text-white bg-sba`}>{props.task.SubTasksList.length}</span>
                        <span className="mx-2"> Sub Task</span></div>
                    <div className="w-50 d-flex"> <progress className={`w-100 border rounded ${progressBarColor}`} value={props.task.SubTasksList.filter(item => item.IsCompleted).length} max={props.task.SubTasksList.length} > </progress>
                        <span className="mx-2">{parseInt((props.task.SubTasksList.filter(item => item.IsCompleted).length / props.task.SubTasksList.length) * 100)}%</span></div>
                </div>
                    <SubTaskContainer subTask={props.task.SubTasksList} parentTask={props.task} />
                </>}
                {/* {props?.task?.ListSubTasks?.map(subTask=>(<SubTaskContainer subTask={subTask} task={props.task}/>))} */}
                {addSubTask?.ActivityTaskId === props.task.ActivityTaskId && <AddSubTaskContainer task={props.task} />}
            </CardBody>
        );
    };
    const SubTaskOperator = ({ subTask, parentTask }) => {
        const [showOwnerDD, setShowOwnerDD] = useState(false);
        const [openOwnerDD, setOpenOwnerDD] = useState(false);
        const updateOwner = (e) => {
            const newOwner = e.value;
            if (newOwner) {
                updateSubTask({ ...subTask, AssignedToUserId: newOwner.AssignedToUserId, AssignedToUserName: newOwner.AssignedToUserName })
            }
            setShowOwnerDD(false);
        }
        return <>
            <li style={{
                display: 'flex',
                alignItems: 'center',
                gap: '8px',
                listStyle: 'none',
                minHeight: '50px'
            }}>
                <input type="checkbox" disabled={subTask.IsCompleted || parentTask.IsCompleted} checked={subTask.IsCompleted}  onChange={(e) => { updateSubTask({ ...subTask, IsCompleted: e.target.checked , CompletedDate : new Date().toISOString() }) }} />
                <span>{subTask.SubTaskName}</span>

                <div className="d-inline-flex gap-1 align-items-center px-2 ms-auto">
                    {showOwnerDD ? <SBAComboBox data={ownerList}
                        value={{ AssignedToUserId: subTask?.AssignedToUserId, AssignedToUserName: subTask?.AssignedToUserName }}
                        textField={"AssignedToUserName"}
                        valueField={"AssignedToUserId"}
                        onChange={updateOwner}
                        className="w-100"
                        disabled={parentTask.IsCompleted || subTask.IsCompleted  }
                        onBlur={() => { setShowOwnerDD(false) }}
                    /> : <>
                        <div className="d-flex justify-content-center align-items-center" onClick={() => { !parentTask.IsCompleted && setShowOwnerDD(true) }}>
                            <span style={{ width: '28px', height: '28px', fontSize: '12px' }} className={`d-inline-flex justify-content-center align-items-center  border border-dark SBA_hand rounded-circle`} >{getShortName(subTask.AssignedToUserName)}</span>
                        </div>
                        <span className="startDate">
                            <i className="fas fa-calendar-alt mx-2"></i>{moment(subTask.DueDateTime).format('MM/DD/YYYY')}
                        </span>
                        {(!parentTask.IsCompleted && !subTask.IsCompleted ) ? <>
                            <i className="fa-solid fa-pencil text-success SBA_hand mx-1 " onClick={() => { editSubTask(subTask) }} />
                            <i className="fa-solid fa-close text-danger SBA_hand mx-1" onClick={() => { removeSubTask(subTask) }} />
                        </> : <>
                        <i className="fa-solid fa-pencil text-success SBA_hand mx-1 " style={{visibility:'hidden'}} />
                            <i className="fa-solid fa-close text-danger SBA_hand mx-1" style={{visibility:'hidden'}}  />
                        </>}

                    </>}</div>
            </li>
        </>
    };
    const CheckBoxRenderer = (props) => {
        const subTask = props.data;
        return <>
            <input type="checkbox" checked={subTask.IsCompleted} onChange={(e) => { updateSubTask({ ...subTask, IsCompleted: e.target.checked }) }} />
        </>
    }
    const SubTaskContainer = ({ subTask, parentTask }) => {
        const subTaskColumnDef = [{ headerName: 'IsCompleted', field: 'IsCompleted', cellRenderer: CheckBoxRenderer, flex: 0.1 }, { headerName: 'SubTaskName', field: 'SubTaskName', type: 'leftAligned', cellStyle: { 'text-align': "left" }, flex: 1 }, { cellRenderer: SubTaskOperator, field: '', type: 'rightAligned' }];
        return <div>
            <ul>
                {subTask.map(sub => (<><SubTaskOperator subTask={sub} parentTask={parentTask} /></>))}
            </ul>
        </div>
    };
    const AddSubTaskContainer = ({ task }) => {
        const [subTask, setSubTask] = useState({
            "ActivitySubTaskId": 0,
            "ActivityTaskId": task.ActivityTaskId,
            "SubTaskName": "",
            "SubTaskBody": " ",
            "AssignedToUserId": task.AssignedToUserId,
            "AssignedToUserName": task.AssignedToUserName,
            "ModifiedByUserId": 0,
            "ModfiedByUserName": "user",
            "ModifiedDate": new Date().toISOString(0),
            "StartDateTime": new Date().toISOString(0),
            "DueDateTime": task.DueDateTime,
            "IsCompleted": false,
            "CompletedDate": ""
        })
        return <div className="my-4">
            <div className="d-flex justify-content-end mb-3" >
                <i className="fa-solid fa-close SBA_hand" onClick={() => { setAddSubTask(null) }} />
            </div>
            <div className="mb-2 d-inline-flex w-100">
                <input className="form-control me-3" type="text" value={subTask.taskName} placeholder="Enter Sub Task Name" onChange={(e) => { setSubTask(value => ({ ...value, SubTaskName: e?.target?.value || '' })) }} />
                <button className="p-sm-btn" onClick={() => { setAddSubTask(addSubTaskToTask(subTask)); }}>Save</button>
            </div>
        </div>
    }
    const Card = (props) => {
        return (
            <TaskBoardCard
                {...props}
                // disabled={props.task.IsCompleted}
                cardHeader={CardHeaderComponent}
                cardBody={CardBodyComponent}
            />
        );
    };
    return (
        <div className="sbTaskBoard">
            <TaskBoard
                columnData={columnsData}
                taskData={resultTasks}
                onChange={(e)=>{onChangeHandler(e)}}
                column={Column}
                style={{
                    height: "70vh",
                }}
                card={Card}
                tabIndex={0}


            >
                <TaskBoardToolbar>
                    {/* <Button icon="add" onClick={onAddColumn}>
          Add Column
        </Button> */}
                    {/* <span className="k-spacer" /> */}
                    {/* <Input
                        placeholder="Search Task..."
                        className="form-control w-50"
                        onChange={onSearchChange}
                        value={filter}
                    /> */}
                </TaskBoardToolbar>
            </TaskBoard>
        </div>
    );
};
const themeColor = {
    todo: "warning",
    inProgress: "info",
    done: "success",
};
const getShortName = (string) => {
    var names = string.split(' '),
        initials = names[0].substring(0, 1).toUpperCase();

    if (names.length > 1) {
        initials += names[names.length - 1].substring(0, 1).toUpperCase();
    }
    return initials;
};
const backgroundColorClasses = [
    'bg-primary',
    'bg-secondary',
    'bg-success',
    'bg-danger',
    'bg-warning',
    'bg-info',
    'bg-light',
    'bg-dark'
];





